module.exports = __webpack_public_path__ + "img/pwa-windows-1.6316e03e.jpg";